import type { PageCard } from '@/play/pageTypes'
import { SandCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'sand',
  number: 14,
  title: 'Sand',
  question: 'Does grainy sand that pours into piles and slides into holes read and feel like sand?',
  status: 'open',
  accent: '#ead6a6',
  CardArt: SandCardArt,
}
